export class MoleculePanelOverviewHeaderMultiRestoreWebhostingVhostActionComponent {
    public templateUrl = require('./multi-restore-webhosting-vhost-action.html?external');
}
